// 设置URL查询参数
export const setQuery = ({ url = window.location.href, list = [], force = false }) => {
    let resultUrl = url;

    try {
        const urlObj = new URL(url);
        const { searchParams } = urlObj;

        list.forEach(item => {
            const { key, value } = item;

            if (force) {
                searchParams.set(key, value);
            } else if (!searchParams.has(key)) {
                searchParams.append(key, value);
            }
        });

        resultUrl = urlObj.href;
    } catch (e) {
        console.error(e);
    }

    return resultUrl;
};

// 获取URL查询参数
export const getQuery = (url, key) => {
    let value = '';

    try {
        const urlObj = new URL(url);
        const { searchParams } = urlObj;

        if (searchParams.has(key)) {
            value = searchParams.get(key);
        }
    } catch (e) {
        console.error(e);
    }

    return value;
};

// 设置URL在客户端的标准查询参数
export const setAppQuery = url => {
    return setQuery({
        url,
        list: [{ key: 'isFull', value: '0' }, { key: 'immersion', value: 'true' }, { key: 'ifengsp', value: '1' }],
    });
};

// 获取ucms类型对应的dispatch类型
export const getDispatchAction = (url, type, base62Id, isGrounds) => {
    if (!isGrounds) {
        return ['web', url];
    }
    const nineDomain = typeof window === 'object' && window.allData?.__nd__ ? window.allData.__nd__ : 'ne883dbn.ifeng.com';
    
    switch (type) {
        case 'article':
            return ['doc', `https://${ nineDomain }/getNewsDocs?aid=ucms_${base62Id}`];
        case 'video':
            return ['phvideo', base62Id];
        case 'miniVideo':
            return ['phvideo', base62Id];
        case 'shortlist':
            return ['short', `https://${ nineDomain }/shortList?id=${base62Id}`];
        case 'short':
            return ['short', `https://${ nineDomain }/getNewsDocs?aid=ucms_${base62Id}`];
        case 'special':
            return ['topic3', `https://${ nineDomain }/newTopic?topicid=${base62Id}&json=y`];
        case 'hotEvent':
            return ['hotspotlist', `https://${ nineDomain }/hotSpotDetailList?eventName=${base62Id}`];
        case 'slide':
            return ['slide', `https://${ nineDomain }/getNewsDocs?aid=ucms_${base62Id}`];
        default:
            return ['web', url];
    }
};
